<template>
  <div>
    <van-field v-model="val" :label="label" :placeholder="placeholder || label"
               :rules="[{ required: required, message: '请输入' + this.label }]">
      <base-button slot="button" @click="show = true">选择</base-button>
    </van-field>
    <van-action-sheet v-model="show" :actions="actions"
                      :title="'选择 ' + label" @select="select" />
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    value: {
      type: String,
      default: ''
    },
    labelAttr: {
      type: String,
      default: 'name'
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      val: this.value,
      actions: this.options
    }
  },
  watch: {
    value: function(value) {
      this.val = value
    },
    options: function(options) {
      this.actions = options
    },
    val: function(value) {
      this.$emit('change', value, this.actions)
    }
  },
  methods: {
    select(action) {
      this.val = action[this.labelAttr]
      this.$emit('change', this.val, this.actions)
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseInputSelect.vue